import "./object-fit";
import $ from "jquery";
import "picturefill";

// picturefill();
